import CommonIFrame from '../atoms/CommonIFrame';

const PriceThreshold = () => {
    return (
        <CommonIFrame
            src="https://sfiudfhishd-ajbdsdb-abdsbdjks.lovable.app/"
            title="Price Threshold"
        />
    );
};

export default PriceThreshold;
